module.exports = __webpack_public_path__ + "img/vol04_character_thumb02.b9a0e2be.png";